module.exports = __webpack_public_path__ + "img/productWX_9.ac720b15.png";